import React from 'react';
import { Bath, ChefHat, CircleParking, Flame, House, Snowflake, Tent, Thermometer, Waves } from 'lucide-react';
import { FadeIn } from './FadeIn';
const FACILITIES = [{
  label: 'Boutique accommodation',
  icon: House
}, {
  label: 'Wood-fired sauna',
  icon: Thermometer
}, {
  label: 'Cedar hot tub',
  icon: Bath
}, {
  label: 'Cold plunges',
  icon: Snowflake
}, {
  label: 'Swimming pool',
  icon: Waves
}, {
  label: 'Dome',
  icon: Tent
}, {
  label: 'Outdoor kitchen',
  icon: ChefHat
}, {
  label: 'Fire pit',
  icon: Flame
}, {
  label: 'Parking',
  icon: CircleParking
}];
export function Facilities() {
  return <section className="bg-creamDeep px-6 py-20 md:px-12 md:py-28" data-id="element-287" data-mp="feiumktzqggw">
      <div className="mx-auto max-w-6xl" data-id="element-288" data-mp="kewydqok7494">
        <div className="mb-12 max-w-2xl" data-id="element-289" data-mp="kfos0vylirwr">
          <FadeIn data-id="element-290" data-mp="1qupnz1nmfa3c">
            <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-291" data-mp="1qv90g2ui569z">
              Facilities
            </p>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-292" data-mp="1vvdg5qnl5wz5">
            <h2 className="font-serif text-4xl leading-tight text-pine md:text-5xl" data-id="element-293" data-mp="3mjvkh4fx6d5n">
              Everything you need to catch your breath, rest, and reset.
            </h2>
          </FadeIn>
        </div>

        <div className="grid grid-cols-2 border-l border-t border-pine/15 sm:grid-cols-3" data-id="element-294" data-mp="3ckd4t071ldje">
          {FACILITIES.map((facility, index) => {
          const Icon = facility.icon;
          return <FadeIn key={facility.label} delay={index * 0.04} data-id="element-295" data-mp="33kq46gm50bre" data-mpi={index}>
                <div className="flex min-h-36 flex-col justify-between border-b border-r border-pine/15 bg-cream p-5 md:min-h-40 md:p-6" data-id="element-296" data-mp="2ytrkr85uqxjx">
                  <Icon className="h-5 w-5 text-ember" data-id="element-297" data-mp="2tvpyked4qi48" />
                  <span className="max-w-[10rem] text-sm font-medium leading-snug text-pine" data-id="element-298" data-mp="2ovlj8rnyjtfl">
                    {facility.label}
                  </span>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}